module.exports = __webpack_public_path__ + "static/img/UA@2x.eca1efe2.jpg";